import auth from "@/store/user/module/auth";

export default function(key: string | number) {
  if (typeof key == "number") {
    key = key.toString();
  } 
  else if (typeof key == "string") {
    if (key.includes("&")) {
      const keys = key.split("&");
      let hasAccess = true;
      if (auth.rights && auth.rights.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          if (!auth.rights.includes(keys[i])) {
            hasAccess = false;
          }
        }
      } else {
        hasAccess = false;
      }
      return hasAccess;
    } else if (key.includes("|")) {
      const keys = key.split("|");
      let hasAccess = false;
      if (auth.rights && auth.rights.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          if (auth.rights.includes(keys[i])) {
            hasAccess = true;
          }
        }
      }
      return hasAccess;
    }
  }
  if (auth.rights && auth.rights.length > 0) {
    return auth.rights.includes(key);
  }
  return false;
}
